import type {
  GroupResultDTO,
  LocalRoleResultDTO,
  UserResultDTO,
} from '@nora-monorepo/nora-api-client';

/**
 * Form-facing member types used by the refactored ConversationModal.
 */
export interface ConversationUserWithLocalRole {
  user: UserResultDTO;
  role: string;
  nonRemovable?: boolean;
}

export interface ConversationGroupWithLocalRole {
  group: GroupResultDTO;
  role: string;
}

export interface ConversationMembers {
  users: ConversationUserWithLocalRole[];
  groups: ConversationGroupWithLocalRole[];
}

export interface ConversationModalFormValues {
  conversationTitle: string;
  members: ConversationMembers;
}

export enum ConversationModalActionState {
  Edit = 'edit',
  Create = 'create',
}

/**
 * Returns the default non-admin conversation role from the loaded role list.
 */
export function getDefaultConversationRole(
  localRoles: LocalRoleResultDTO[],
): LocalRoleResultDTO {
  const defaultRole = localRoles.find(role => role.defaultUser);

  if (!defaultRole) {
    throw new Error('No default conversation role found');
  }

  return defaultRole;
}

/**
 * Returns the default admin conversation role from the loaded role list.
 */
export function getDefaultConversationAdminRole(
  localRoles: LocalRoleResultDTO[],
): LocalRoleResultDTO {
  const defaultAdminRole = localRoles.find(role => role.defaultAdmin);

  if (!defaultAdminRole) {
    throw new Error('No default conversation admin role found');
  }

  return defaultAdminRole;
}
